import { render } from "./FormLoader.vue?vue&type=template&id=7f77198c&scoped=true"
import script from "./FormLoader.vue?vue&type=script&lang=js"
export * from "./FormLoader.vue?vue&type=script&lang=js"

import "./FormLoader.vue?vue&type=style&index=0&id=7f77198c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f77198c"]])

export default __exports__